













































import Vue from "vue";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
// import Search from "@/components/Search.vue";
import { state } from "./data/state";
import { computed } from "@vue/composition-api";
import { UsePopup } from "@/components/root/popup/popup.state";
import { SharedState } from "@/common/state";
import { InformationType } from "@/common/models";
import { remToPx } from "@/common/dom.functions";
export default Vue.extend({
  components: { DropDownSimple },
  setup() {
    const {
      query,
      info_types,
      selected_info_type,
      set_selected_info_type,
      entity_types,
      selected_entity_type,
      set_selected_entity_type,
      sensitivity_levels,
      selected_sensitivity_level,
      set_selected_sensitivity_level,
      is_filter_changed,
      on_filters_updated,
      current_tab,
      affinity_levels,
      selected_affinity_level,
      set_selected_affinity_level,
      departments,
      set_selected_department,
      selected_department,
    } = state;

    const entities_type = computed(() => {
      switch (current_tab.value) {
        case "trusted":
          return "<b class='text-level-l'>trusted</b> with";
        case "untrusted":
          return "<b class='text-level-h'>untrusted</b> with";
        case "trustedAsViewerOnly":
          return "that should only <b class='text-primary'>view</b>";
        case "unmanaged":
        default:
          return "with unknown trust for";
      }
    });

    const show_sub_labels = (ev: MouseEvent) => {
      const l1s = SharedState.typesByCategories.value.get(
        selected_info_type.value.id
      ) as InformationType[];
      const sub_labels = l1s
        .filter(
          // @ts-ignore
          (l) => l.sensitivityLevel === selected_sensitivity_level.value.id
        )
        .map((l) => l.labelName);
      UsePopup.showDisplayPopup({
        event: ev,
        type: "TextDisplayPopup",
        items: sub_labels,
        position: "bottom",
        width: remToPx(20),
      });
    };

    return {
      query,
      info_types,
      selected_info_type,
      set_selected_info_type,
      entity_types,
      selected_entity_type,
      set_selected_entity_type,
      sensitivity_levels,
      selected_sensitivity_level,
      set_selected_sensitivity_level,
      is_filter_changed,
      entities_type,
      current_tab,
      show_sub_labels,
      affinity_levels,
      selected_affinity_level,
      set_selected_affinity_level,
      departments,
      set_selected_department,
      selected_department,
    };
  },
});
